import AccountSettings from './AccountSettings';
import TermsOfServiceDialog from './terms-of-service/TermsOfService';

export * from './phoneNumbers.reducer';
export { TermsOfServiceDialog };

export default AccountSettings;
